import { BindAppleTokenOptionsV2 } from '../types';
import { createVerificationIntent } from '../utils/createVerificationIntent';

export const createAppleTokenBindingApi2 = async (apiHost: string, params: BindAppleTokenOptionsV2) => {
    return createVerificationIntent(apiHost, {
        ...params,
        flow: 'apple-pay',
    });
};
